import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  wrapper: {
    marginBottom: `${styles.spacing(6)}px`,
    borderRadius: '0 0 12px 12px',
    boxShadow: styles.shadows.regular,
  },
  heading: {
    padding: `${styles.spacing(3)}px`,
    background: styles.palette.background.dark,
    borderRadius: '12px 12px 0 0',
  },
  title: {
    color: styles.palette.text.inverse,
    fontSize: 30,
    fontWeight: 300,
  },
  textWrapper: {
    padding: `${styles.spacing(2)}px ${styles.spacing(3)}px`,
  },
});
